var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}]},[(_vm.isLineLeaderEnroll)?_c('CorporateStaffDashboardMP'):_c('CorporateStaffDashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }